<template>
    <div>
        <l-marker
            :lat-lng="getCoordinates(item.geometry.coordinates[0])"
            @click="openModal(item.geometry.coordinates[0])"
        >
            <l-icon
                :icon-url="marker"
                :icon-size="iconSize"
                :icon-anchor="[15.375, 37.5]"
                ><img :src="marker" class="marker-icon"
            /></l-icon>
        </l-marker>
        <l-marker
            :lat-lng="
                getCoordinates(
                    item.geometry.coordinates[
                        item.geometry.coordinates.length - 1
                    ]
                )
            "
            @click="
                openModal(
                    item.geometry.coordinates[
                        item.geometry.coordinates.length - 1
                    ]
                )
            "
        >
            <l-icon
                :icon-url="marker"
                :icon-size="iconSize"
                :icon-anchor="[15.375, 37.5]"
                ><img :src="marker" class="marker-icon"
            /></l-icon>
        </l-marker>
        <l-polyline
            :lat-lngs="getCoordinates(item.geometry.coordinates)"
            :color="style.color"
            :weight="style.weight"
        ></l-polyline>
    </div>
</template>
<script>
import { LIcon, LPolyline, LMarker } from "vue2-leaflet";

export default {
    name: "LineStringMarkerComponent",
    components: {
        LPolyline,
        LIcon,
        LMarker,
    },

    props: {
        item: {
            default: () => {},
        },
        iconSize: {
            default: () => [30.75, 37.5],
        },
    },

    mounted() {
        if (this.item.event_or_works_class === "_danger") {
            this.style.color = "#EF4035";
        } else {
            this.style.color = "#FFE033";
        }
    },

    data() {
        return {
            style: {
                color: "blue",
                weight: 10,
            },
        };
    },

    computed: {
        marker() {
            if (this.item.event_or_works_class === "_danger") {
                return "/svg/map/markers/conditions/hac-danger.svg";
            } else {
                return "/svg/map/markers/conditions/hac-warning.svg";
            }
        },
    },

    methods: {
        getCoordinates(coordinates) {
            return coordinates;
        },

        openModal(coordinates) {
            this.$parent.$parent.$parent.$refs.map.mapObject.setView(
                coordinates,
                12
            );

            this.$store.commit("setData", {
                name: "selectedCondition",
                data: this.item,
            });
        },
    },
};
</script>
